import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { AngleDown } from '@octopus-do/octopus-storybook/icons'
import cx from 'classnames'
import { forwardRef } from 'react'

import css from './styles.module.scss'

interface Props {
  label: string
}

export const SelectTrigger = forwardRef<HTMLButtonElement, Props>(
  ({ label }, ref) => {
    // The menu doesn't count a press on its trigger as an outside click, so a
    // second click lands here and closes it.
    const { active, toggle } = DropdownMenu.useTrigger()

    return (
      <button
        ref={ref}
        type="button"
        onClick={toggle}
        className={cx(css.trigger, active && css.active)}
      >
        {label}
        <AngleDown className={css.icon} />
      </button>
    )
  }
)
